import CONST_REQUEST from '../../constants/request';
import * as api from '../../api/dict.js';
import apiTools from '../../utils/store'

const types = {
    ...apiTools.getTypes([
        'dictList',
    ]),
}

const getDefaultState = () => {
    return {
        ...apiTools.getStates([
            'dictList',
        ]),
    }
}

const getters = {
        ...apiTools.getGetters([
            'dictList',
        ])
    }

const buildAction = (apiName) => {
    return ({ commit }, params) => {
        return api[apiName](params).then((res) => {
            if (res.code == CONST_REQUEST.CODE_SUCCESS) {
                return res
            } else {
                throw new Error(res.msg)
            }
        })
    }
}

const actions = {
        ...apiTools.getActions([
            'getDictList',
        ], { types, api, CONST_REQUEST }),
    }

const mutations = {
    ...apiTools.getMutations([
        'dictList',
    ], { types, CONST_REQUEST })
}


export default {
    namespaced: true,
    state: getDefaultState(),
    getters,
    actions,
    mutations
}